module.exports = __webpack_public_path__ + "img/icon-manage-beneficiaries.6b929a78.svg";